import React,{Component} from "react";
// import axios from "axios";

class DescribeCourse extends Component{
    state ={
        course: [],
    }
    componentDidMount() {
        this.setState({course: this.props.course})
    }
    componentDidUpdate(prevProps) {
        if (this.props.course !== prevProps.course) {
            this.setState({course: this.props.course})
            // this.fetchCourses();
        }
    }
    // fetchCourses = async () => {
    //     const accessToken = localStorage.getItem("accessToken");
        
    
    //     try {
    //         const course_id = this.props.course_id
    //         const courseId = parseInt(course_id, 10);
    //         let headers = {}; // Initialize an empty headers object

    //     if (accessToken) {
    //         headers = {
    //             Authorization: `Bearer ${accessToken}`,
    //         };
    //     }
    //         const response = await axios.get("https://api.geoinfoacademy.com/api/courses/" + courseId, {
    //             headers: headers,
                
    //         });
    //           this.setState({ course: response.data });
    //           console.log("API Response:", response.data);
    //     } catch (error) {
    //         console.error("Error fetching data:", error);
    //     }
    // };

    render(){
        const course =  this.state.course
        return(
            <section className="course_description">
                        <h3>Course description</h3>
                            <p>{course.description}</p>
                    </section>
        )
    }
}

export default DescribeCourse